<template>
  <div data-app>
    <div class="uk-card uk-card-small_ uk-card-default">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle uk-grid-stack" data-uk-grid>
          <div class="uk-width-expand">
            <h3 class="uk-card-title uk-margin-remove-top">
              Знакомство с аккаунтом
            </h3>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-margin-auto">
          <video src="/video/retoucher1-ready2.mp4" controls data-uk-video="autoplay: false"></video>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "AcquaintanceWithTheAccount",
  components: {
  },
  data: () => ({
    local_page_keys: null,
  }),
}
</script>

<style>
  audio,
  canvas,
  iframe,
  img,
  svg,
  video {
    vertical-align: middle;
  }
  canvas,
  img,
  video {
    /* 1 */
    max-width: 100%;
    /* 2 */
    height: auto;
    /* 3 */
    box-sizing: border-box;
  }
  @import '../../../assets/css/uikit/utility.css';
</style>